import { css } from "@emotion/css"

import Anchor from "@p-ban/common/src/components/html/Anchor"
import Image from "@p-ban/common/src/components/html/Image"

import _1clickButton from "./1clickButton.png"
import _1clickButtonHover from "./1clickButtonHover.png"

const links = [
  { text: "サービス紹介", href: "/service/" },
  { text: "注文方法", href: "/order/" },
  { text: "セミナー", href: "/seminar/" },
  { text: "CADダウンロード", href: "/cad/" },
  { text: "お問い合わせ", href: "/customer_support/" },
] as const

const HeaderNav = () => {
  return (
    <nav className={styles.nav}>
      <div>
        <ul className={styles.list}>
          {links.map(({ text, href }) => (
            <li key={href}>
              <Anchor className={styles.link} href={href}>
                {text}
              </Anchor>
            </li>
          ))}
        </ul>
        <div>
          <Anchor
            className={styles.oneClickLink}
            href="/kiban/com/csComEst.do"
            newTab
            render={({ isHovered }) => (
              <Image
                src={isHovered ? _1clickButtonHover : _1clickButton}
                width={368}
                height={38}
                alt="お見積り・ご注文はこちら　1-Click見積へ"
              />
            )}
          />
        </div>
      </div>
    </nav>
  )
}

export default HeaderNav

const styles = {
  nav: css`
    background: #005a6c;
    > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 1400px;
      padding: 0 30px;
      margin: 0 auto;
    }
  `,
  list: css`
    display: flex;
    padding: 12px 0px;
    list-style: none;
  `,
  link: css`
    display: block;
    padding: 0px 15px;
    font-size: 16px;
    font-weight: bold;

    color: #fff;
    border-right: 1px #fff solid;
    li:first-child & {
      padding-left: 0px;
    }
    &:hover {
      color: #f7a500;
      text-decoration: none;
    }
  `,
  oneClickLink: css`
    display: block;
    width: 368px;
    height: 38px;
    background: #f7a500;
    border-radius: 8px;
    box-shadow: 2px 2px 3px #333;
  `,
}
